import "./DashboardSidebar.css";
import { NavLink } from "react-router-dom";
import sidebarLogo from "../../imgs/sidebarLogo.webp";
import { isStoreProductsOnlyAdmin } from "../../utils/adminAccess";

const STORE_PRODUCTS_LINKS = [
  { to: "/dashboard/store/products", icon: "uil uil-package", label: "Store Products" },
  { to: "/dashboard/store/add-product", icon: "fa-solid fa-plus", label: "Add Product" },
];

const SIDEBAR_SECTIONS = [
  {
    title: "Store",
    icon: "uil uil-store",
    links: [
      ...STORE_PRODUCTS_LINKS,
      { to: "/dashboard/store/control", icon: "fa-solid fa-sliders", label: "Store Control" },
      { to: "/dashboard/store/product-reviews", icon: "uil uil-star", label: "Customer Reviews" },
      { to: "/dashboard/orders", icon: "uil uil-shopping-cart", label: "Orders" },
    ],
  },
  {
    title: "Projects",
    icon: "uil uil-presentation-edit",
    links: [
      { to: "/dashboard/add-project", icon: "fa-solid fa-plus", label: "Add Project" },
      { to: "/dashboard/projects", icon: "uil uil-chart", label: "Projects" },
    ],
  },
  {
    title: "Communications",
    icon: "uil uil-chat-bubble-user",
    links: [
      { to: "/dashboard/messages", icon: "uil uil-message", label: "Messages" },
      { to: "/dashboard/jobs", icon: "uil uil-briefcase-alt", label: "Jobs" },
    ],
  },
  {
    title: "Reviews",
    icon: "uil uil-star",
    links: [
      { to: "/dashboard/add-review", icon: "fa-solid fa-plus", label: "Add Review" },
      { to: "/dashboard/reviews", icon: "uil uil-star", label: "Reviews" },
    ],
  },
  {
    title: "Partners",
    icon: "uil uil-users-alt",
    links: [{ to: "/dashboard/add-partner", icon: "fa-solid fa-plus", label: "Add Partner" }],
  },
  {
    title: "Content",
    icon: "fa-solid fa-sliders",
    links: [
      { to: "/dashboard/content/home", icon: "fa-solid fa-sliders", label: "Home" },
      { to: "/dashboard/content/about", icon: "fa-solid fa-sliders", label: "About us" },
      { to: "/dashboard/content/contact-join", icon: "fa-solid fa-sliders", label: "Contact & Join" },
      { to: "/dashboard/store/policies", icon: "fa-solid fa-file-lines", label: "Policies" },
    ],
  },
];

function getVisibleSections() {
  if (isStoreProductsOnlyAdmin()) {
    return [
      {
        title: "Store",
        icon: "uil uil-store",
        links: STORE_PRODUCTS_LINKS,
      },
    ];
  }
  return SIDEBAR_SECTIONS;
}

function DashboardSidebar({ isOpen, closeSidebar }) {
  const visibleSections = getVisibleSections();
  const showDashboardHome = !isStoreProductsOnlyAdmin();

  return (
    <div className={`Dashsidebar ${isOpen ? "open" : "closed"}`}>
      <button className="close-btn" onClick={closeSidebar}>
        <i className="fa-solid fa-xmark"></i>
      </button>
      <div className="heading">
        <div className="side-logo">
          <img src={sidebarLogo} alt="logo" />
        </div>
        <ul className="linkss">
          {showDashboardHome ? (
            <li>
              <NavLink
                to="/dashboard"
                className={({ isActive }) => (isActive ? "active" : "")}
                onClick={closeSidebar}
              >
                <i className="uil uil-estate"></i> Dashboard
              </NavLink>
            </li>
          ) : null}
          {visibleSections.map((section) => (
            <li key={section.title} className="sidebar-section-label">
              <span>
                <i className={section.icon}></i> {section.title}
              </span>
            </li>
          )).flatMap((sectionLabelLi, sectionIndex) => {
            const section = visibleSections[sectionIndex];
            const links = section.links.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  className={({ isActive }) => (isActive ? "active" : "")}
                  onClick={closeSidebar}
                >
                  <i className={item.icon}></i> {item.label}
                </NavLink>
              </li>
            ));
            return [sectionLabelLi, ...links];
          })}
        </ul>
      </div>
      <div className="log-out">
        {/* <NavLink to={"/dashboard/profile"} className="info">
          <i className="fa-regular fa-circle-user"></i>
          <p>Profile</p>
        </NavLink> */}
        <span className="log-btn">
          <i className="fa-solid fa-arrow-right-from-bracket"></i>
        </span>
      </div>
    </div>
  );
}

export default DashboardSidebar;
